<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="1000px"
      v-bind:body-style="{ height: '680px' }"
    >
    <!-- 表单 -->
    <div >
      <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="网点名称:" prop="networkName">
              <a-input v-model="searchList.networkName" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="网点编号:" prop="networkCode">
              <a-input v-model="searchList.networkCode" :allowClear="true" placeholder="请输入" :disabled="netDisabled"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "12">
            <a-form-model-item label="使用状态:" prop="networkStatus">
              <a-select v-model="searchList.networkStatus"  placeholder="请选择使用状态">
                <a-select-option v-for="item in useStatusList" :key="item.value" :value="item.value" style="width: 120px">
                    {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="所在地址:" prop="networkAddress">
              <a-input v-model="searchList.networkAddress" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="网点说明:" prop="remark" :label-col="{ span: 3 }">
            <a-textarea :row="4" v-model="searchList.remark" :allowClear="true" placeholder="请输入" style="width: 813px;"/>
          </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="医护团队:" prop="medicalTeam" :label-col="{ span: 3 }" >
              <a-textarea :row="4" v-model="searchList.medicalTeam" :allowClear="true" placeholder="请输入" style="width: 813px;"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="特色科室:" prop="specialtyDepartment" :label-col="{ span: 3 }">
              <a-textarea :row="4" v-model="searchList.specialtyDepartment" :allowClear="true" placeholder="请输入" style="width: 813px;"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item label="标签:" prop="networkLabel" :label-col="{ span: 3 }" style="display: flex;">
              <a-button
                v-for="(item, index) in netWorkList"
                :key="index"
                @click="btnChange(index)"
                :class="item.checked === true ? 'changePri' : 'primary'"
                style="margin-left: 15px;"
                v-if="butVisible"
                ><a-badge color="red"/>{{ item.label }}</a-button
              > 
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span = "24">
            <a-form-model-item
              label="配图"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 20 }"
              required
            >
              <upload :downid="netWorkId" uploadNum="1" :uploadAgain="uploadAgain" :fileNum="fileNum" @listen ="listen"></upload>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row>
          <a-col :span = "12">
            <a-form-model-item label="网点经纬度:" prop="reson">
              <a-input v-model="searchList.reson" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item prop="reson">
              <a-input v-model="searchList.reson" :allowClear="true" placeholder="请输入"/>
            </a-form-model-item>
          </a-col>
        </a-row> -->
      </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import{
  querynetworkById
} from "@/api/api.js";
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from "@common/services/dictionary.service";
export default {
  components: { upload },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    netWorkId: {
      type: String,
      default: () => "",
    }, //网点ID
    data: {
      type: Array,
      default: () => [],
    },//返回信息
  },
  data() {
    return {
      id: "",
      uploadAgain: false,
      fileNum: 0,
      imgUrl :'',
      imgId: [],
      tagVisible: false,
      
      visible: true,

      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      //绑定值
      searchList: {
        id: "",
        networkName: "",
        networkCode: "",
        networkStatus: undefined,
        networkAddress:"",
        remark: "",
        medicalTeam: "",
        specialtyDepartment: "",
        networkLabel: "",
        imgUrl:"",
      },

      //校验规则
      rules: {
        networkName: [
          {
            required: true,
            message: "网点名称不能为空！",
            trigger: "blur",
          },
          {
            max: 200,
            message: "不可超过200字",
            trigger: "blur",
          }
        ],
        networkCode: [
          {
            required: true,
            message: "网点编号不能为空！",
            trigger: "blur",
          },
          {
            max: 64,
            message: "不可超过64字",
            trigger: "blur",
          }
        ],
        networkStatus: [
          {
            required: true,
            message: "使用状态不能为空！",
            trigger: "change",
          },
        ],
        networkAddress: [
          {
            required: true,
            message: "所在地址不能为空！",
            trigger: "blur",
          },
          {
            max: 100,
            message: "不可超过100字",
            trigger: "blur",
          }
        ],
        remark: [
          {
            required: true,
            message: "网点说明不能为空！",
            trigger: "blur",
          },
          {
            max: 200,
            message: "不可超过200字",
            trigger: "blur",
          }
        ],
        medicalTeam: [
          {
            required: true,
            message: "医护团队不能为空！",
            trigger: "blur",
          },
          {
            max: 200,
            message: "不可超过200字",
            trigger: "blur",
          }
        ],
        specialtyDepartment: [
          {
            required: true,
            message: "特色科室不能为空！",
            trigger: "blur",
          },
          {
            max: 1000,
            message: "不可超过1000字",
            trigger: "blur",
          }
        ],
        networkLabel: [
          {
            required: true,
            message: "标签不能为空！",
            trigger: "change",
          },
        ],
      },

      //标签list
      changeLeftBackground: "",
      butVisible: true,
      netWorkList: [],

      //使用状态
      useStatusList: [],

      //网点编号是否可以修改
      netDisabled:false,
    }
  },
  mounted() {
    // 获取字典
    DictionaryService.getAllNeedDic(["NETWORK_LABEL","USE_STATUS"]).then((res) => {
      //标签
      this.netWorkList = DictionaryService.getOptions("NETWORK_LABEL");

      //使用状态
      this.useStatusList = DictionaryService.getOptions("USE_STATUS");
      this.searchList.networkStatus = this.useStatusList[0].value;

      //0为未选中状态 1为选中状态
      this.netWorkList.forEach(item => {
        item['checked'] = false;
      });

      if (this.modalTitle == '编辑服务网点') {
        this.netDisabled = true;
        querynetworkById({id: this.netWorkId}).then(
          (res) => {
            if (res.code == '0000') {
              this.searchList = res.content;
              this.searchList.imgUrl = res.content.attachments[0].busId;

              let arr = [];
              arr = res.content.networkLabelKey.split(',');
              for (let i = 0; i < arr.length; i++){
                for (let j = 0; j < this.netWorkList.length; j++){
                  if (arr[i] == this.netWorkList[j].value) {
                    this.netWorkList[j].checked = true;
                    break;
                  }
                } 
              }
            }
          },
          (err) => {
            this.$message.error('查询商品失败')
          }
        )
      }

    }); 

    this.searchList.id = this.netWorkId;
  },
  methods: {
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      let obj = [];
      this.netWorkList.forEach((item) => {
        if (item.checked == 1) {
          obj.push(item.value)
        }
      })
      var separator = ','; // 分隔符
      // 使用 join() 函数进行拼接
      this.searchList.networkLabel = obj.join(separator);
      if (this.searchList.imgUrl == "" || this.searchList.imgUrl == null || this.searchList.imgUrl == undefined) {
        return this.$message.warning("请上传配图！")
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("handleOk",this.modalTitle,this.searchList); 
        }
      });
    },

    //监听附件组件
    listen(val) {
      this.uploadAgain = false;
      console.log(val.length)
      if(val.length == 0){
        this.imgUrl = false;
        this.searchList.imgUrl ="";
      } else {
        this.imgUrl = true;
        this.imgId = val[0].id;
        this.searchList.imgUrl = val[0].id;
        this.uploadAgain = true;//监听是否已上传文件
        console.log(this.searchList.imgUrl)
      }
      this.fileNum = val.length;
    },

    //标签改变
    tagChange() {
      this.tagVisible = !this.tagVisible;
    },

    // 配置最近几小时按钮颜色
    btnChange(index) {
      this.butVisible = false;
      this.netWorkList[index].checked = !this.netWorkList[index].checked;
      this.butVisible = true;
   }


  },
}
</script>

<style scoped>
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}

.changePri {
  background: #16828b;
  border-color: #16828b;
  color: white;
}

</style>
